(function () {
  'use strict';

  /* @ngdoc object
   * @name vcdms.vcdoctype
   * @description
   *
   */
  angular
    .module('vcdms.vcdoctype', [
    ]);
}());
